




















import VirtualTable from "@/components/table/VirtualTable.vue";
import TableRow from "./TableRow.vue";
import { pdf_state } from "@/views/reports/data/pdf/state.pdf";
import { table_config } from "./table.config";
import Vue from "vue";
import { onBeforeUnmount, onMounted } from "@vue/composition-api";
import { emptyFn } from "@/fp";
import { ReportTemplate } from "../../data/pdf/model";
import { EventBus } from "@/eventbus";
import { UseDrillDownMenu } from "@/components/root/drilldown-menu/drilldown-menu.state";
import { UseModal } from "@/components/root/modal";
import TemplateGridItem from "./TemplateGridItem.vue";
import { SharedState } from "@/common/state";
import ReportTemplateDetailsModalVue from "../ReportTemplateDetailsModal.vue";
export default Vue.extend({
  components: { VirtualTable /* TemplateGridItem */ },
  setup(_, { root: { $router } }) {
    const { report_templates } = pdf_state;

    const subs = {
      on_menu: emptyFn(),
    };

    const show_row_menu = async (payload: {
      item: ReportTemplate;
      event: MouseEvent;
    }) => {
      const { event, item } = payload;
      const is_owner =
        payload.item.author == SharedState.loggedUser.value.email;
      let menu = [];
      if (is_owner) {
        menu = [
          {
            isCategory: false,
            name: "Edit Template",
            disable: false,
            isPremium: false,
            subItems: [],
            icon: "Edit2",
            action: "edit_template",
          },
          {
            isCategory: false,
            name: "Delete Template",
            disable: false,
            isPremium: false,
            subItems: [],
            icon: "Trash",
            action: "delete_template",
          },
        ];
      } else {
        menu = [
          {
            isCategory: false,
            name: "View Template Details",
            disable: false,
            isPremium: false,
            subItems: [],
            icon: "Detection",
            action: "view_template",
          },
          {
            isCategory: false,
            name: "Duplicate Template",
            disable: false,
            isPremium: false,
            subItems: [],
            icon: "Duplicate",
            action: "duplicate_template",
          },
        ];
      }

      const menu_res = await UseDrillDownMenu().show({
        event: event,
        menu,
      });

      if (menu_res.didUserSelectedAnAction) {
        switch (menu_res.actionSelected) {
          case "edit_template":
            $router.push({
              name: "ReportGenerator",
              query: { action: "edit", id: item.id },
            });
            break;
          case "view_template":
            UseModal().show(ReportTemplateDetailsModalVue, {
              sections: payload.item.sections,
              name: payload.item.name,
            });
            break;
          case "duplicate_template":
            pdf_state.create_template_copy(payload.item);
            break;
          case "delete_template":
            let desc;
            if (item.scheduled != "none") {
              desc =
                "Are you sure you want to delete this template and unschedule it?";
            } else {
              desc = "Are you sure you want to delete this template?";
            }
            const delete_res = await UseModal().showSimple({
              title: "Delete Template",
              desc,
              submitBtnText: "Delete",
              cancelBtnText: "Cancel",
            });
            if (delete_res.type == "success") {
              pdf_state.delete_template(item.id);
            }
            break;
          default:
            break;
        }
      }
    };
    onMounted(() => {
      subs.on_menu = EventBus.listen("showTemplateMenu", show_row_menu);
    });

    onBeforeUnmount(() => {
      Object.values(subs).forEach((unsub) => unsub());
    });
    return {
      table_config,
      report_templates,
      TableRow,
      items: report_templates.items,
      is_loading: report_templates.is_loading,
      has_no_results: report_templates.has_no_results,
    };
  },
});
